module.exports = __webpack_public_path__ + "static/media/kloiePellegrini.a4ffc869.jpg";